function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { uuid } from 'uuidv4';
import Toggle from 'react-toggle';
import Collapse, { Panel } from 'rc-collapse';
import { isAndroid } from 'react-device-detect';
import LogBookEntry from '../../../model/LogBookEntry';
import { Input, TextArea } from '../../Input';
import RiderPanel from './RiderPanel';
import './LogBookEntryPanel.css';
var MOTO_NAMES = {
  'sixteenth': '<sup>1</sup>/<sub>16</sub>',
  'eighth': '<sup>1</sup>/<sub>8</sub>',
  'quarter': '<sup>1</sup>/<sub>4</sub>'
};

var LogBookEntryPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(LogBookEntryPanel, _React$Component);

  function LogBookEntryPanel(props) {
    var _this;

    _classCallCheck(this, LogBookEntryPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LogBookEntryPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "retrieveLogBookEntry", function () {
      var _this$props = _this.props,
          storage = _this$props.storage,
          logBookEntryId = _this$props.logBookEntryId;
      LogBookEntry.get(storage, logBookEntryId).then(function (logBookEntry) {
        if (_this.props.logBookEntryId === logBookEntry.id) {
          _this.setState({
            logBookEntry: logBookEntry
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "mapMotoName", function (motoName) {
      return MOTO_NAMES[motoName] || motoName;
    });

    _defineProperty(_assertThisInitialized(_this), "updateLogBookEntry", function () {
      var storage = _this.props.storage;
      var _this$state = _this.state,
          logBookEntry = _this$state.logBookEntry,
          deleted = _this$state.deleted;

      if (deleted || logBookEntry.deleted) {
        return;
      }

      return logBookEntry.save(storage).then(function (r) {
        _this.setState({
          logBookEntry: logBookEntry
        });
      }, function (error) {
        console.error(error);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEntryFeeChanged", function (event) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          updateLogBookEntry = _assertThisInitialize.updateLogBookEntry;

      var logBookEntry = _this.state.logBookEntry;
      logBookEntry.entryFee = event.target.value;
      updateLogBookEntry();
      return event.target.value;
    });

    _defineProperty(_assertThisInitialized(_this), "onTotalMotosChanged", function (event) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          updateLogBookEntry = _assertThisInitialize2.updateLogBookEntry;

      var logBookEntry = _this.state.logBookEntry;
      logBookEntry.totalMotos = event.target.value;
      updateLogBookEntry();
      return event.target.value;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmittedToUSABMX", function (event) {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          updateLogBookEntry = _assertThisInitialize3.updateLogBookEntry;

      var logBookEntry = _this.state.logBookEntry;
      logBookEntry.submittedToUSABMX = event.target.checked;
      updateLogBookEntry();
    });

    _defineProperty(_assertThisInitialized(_this), "deleteLogBookEntry", function () {
      var storage = _this.props.storage;
      var logBookEntry = _this.state.logBookEntry;

      _this.setState({
        deleted: true
      }, function () {
        setTimeout(function () {
          logBookEntry.delete(storage).then(function () {
            _this.props.deleteLogBookEntry(logBookEntry);
          }).catch(function (error) {
            console.error(error);

            _this.setState({
              deleted: false
            });
          });
        }, 250);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editLogBookEntry", function () {
      var logBookEntry = _this.state.logBookEntry;

      if (!logBookEntry) {
        return;
      }

      _this.props.editLogBookEntry(logBookEntry);
    });

    _defineProperty(_assertThisInitialized(_this), "editLogBookEntryDate", function () {
      var logBookEntry = _this.state.logBookEntry;

      if (!logBookEntry) {
        return;
      }

      _this.props.editLogBookEntryDate(logBookEntry);
    });

    _this.state = {};
    return _this;
  }

  _createClass(LogBookEntryPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.retrieveLogBookEntry();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.logBookEntryId !== prevProps.logBookEntryId) {
        this.retrieveLogBookEntry();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var selectMoto = this.selectMoto,
          mapMotoName = this.mapMotoName,
          updateLogBookEntry = this.updateLogBookEntry,
          onEntryFeeChanged = this.onEntryFeeChanged,
          onTotalMotosChanged = this.onTotalMotosChanged,
          deleteLogBookEntry = this.deleteLogBookEntry,
          editLogBookEntry = this.editLogBookEntry,
          editLogBookEntryDate = this.editLogBookEntryDate;
      var _this$props2 = this.props,
          width = _this$props2.width,
          setCurrentLogBookEntry = _this$props2.setCurrentLogBookEntry,
          storage = _this$props2.storage;
      var _this$state2 = this.state,
          selectedMoto = _this$state2.selectedMoto,
          deleted = _this$state2.deleted,
          logBookEntry = _this$state2.logBookEntry;

      if (!logBookEntry) {
        return React.createElement("div", {
          className: "logbook-entry placeholder",
          style: {
            width: "".concat(width, "px")
          }
        });
      }

      var isPractice = logBookEntry.isPractice();
      return React.createElement("div", {
        className: "logbook-entry ".concat(deleted ? 'deleted' : '', " ").concat(isAndroid ? 'android' : ''),
        style: {
          width: "".concat(width, "px")
        },
        id: logBookEntry.id
      }, React.createElement("div", {
        className: "header"
      }, React.createElement("div", {
        className: "title",
        onClick: editLogBookEntry
      }, logBookEntry.event.name), React.createElement("div", {
        className: "track",
        onClick: editLogBookEntry
      }, logBookEntry.venue.name), React.createElement("div", {
        className: "date",
        onClick: editLogBookEntryDate
      }, logBookEntry.date.toLocaleString(DateTime.DATE_HUGE)), React.createElement("div", {
        className: "category-points"
      }, React.createElement("div", {
        className: "category",
        onClick: editLogBookEntry
      }, logBookEntry.category), !isPractice && React.createElement("div", {
        className: "points",
        onClick: editLogBookEntry
      }, logBookEntry.pointsClass.name)), React.createElement("div", {
        className: "extras"
      }, React.createElement(Input, {
        className: "compact",
        label: "Entry Fee",
        locked: false,
        active: false,
        type: "number",
        onChange: onEntryFeeChanged,
        value: logBookEntry.entryFee
      }), !isPractice && React.createElement(Input, {
        className: "compact total-motos",
        label: "Total Motos",
        locked: false,
        active: false,
        type: "number",
        onChange: onTotalMotosChanged,
        value: logBookEntry.totalMotos
      }))), React.createElement("div", {
        className: "riders"
      }, logBookEntry.riderEntries.map(function (entry) {
        var _React$createElement;

        return React.createElement(RiderPanel, (_React$createElement = {
          key: entry.id,
          logBookEntry: logBookEntry,
          entry: entry,
          mapMotoName: mapMotoName,
          width: width,
          updateLogBookEntry: updateLogBookEntry,
          deleteLogBookEntry: deleteLogBookEntry,
          isPractice: isPractice,
          setCurrentLogBookEntry: setCurrentLogBookEntry
        }, _defineProperty(_React$createElement, "width", width), _defineProperty(_React$createElement, "storage", storage), _React$createElement));
      })), !isPractice && React.createElement("div", {
        className: "footer"
      }, React.createElement("div", {
        className: "submitted"
      }, React.createElement("div", {
        className: "caption"
      }, "posted to USA BMX"), React.createElement(Toggle, {
        defaultChecked: logBookEntry.submittedToUSABMX,
        icons: false,
        onChange: this.handleSubmittedToUSABMX
      }))));
    }
  }]);

  return LogBookEntryPanel;
}(React.Component);

export default LogBookEntryPanel;